import moment from 'moment';
import { TimeSpan } from './chronos.type';

export function createTodayTimespan(): TimeSpan {
  return [moment().local().startOf('day'), moment().local().startOf('day')];
}
